/* ============================================================
   BUILD YOUR BUNDLE — state machine + cart-add
   Vanilla JS, no jQuery. Runs only on /pages/build-your-bundle.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-byob-root]');
  if (!root) return;

  // ---- Config (from data attrs set by Liquid) -----------------
  var config = JSON.parse(root.getAttribute('data-byob-config') || '{}');
  // {
  //   tiers: [{ size: 3, onceDiscount: 0.10, subDiscount: 0.20, parentVariantId, sellingPlanId },
  //           { size: 5, onceDiscount: 0.15, subDiscount: 0.30, parentVariantId, sellingPlanId }]
  // }
  // Sub rates are applied to recurring contracts by Stay.ai's add-discount endpoint;
  // once rates are applied at checkout by the byob-discount Shopify Function.
  // See docs/byob-discount-plan.md.

  // ---- DOM refs ----------------------------------------------
  var tierBtns = root.querySelectorAll('[data-byob-tier]');
  var pillBtns = root.querySelectorAll('[data-byob-category]');
  var productCards = root.querySelectorAll('[data-byob-product]');
  var emptyEl = root.querySelector('[data-byob-empty]');
  var slotsEl = root.querySelector('[data-byob-slots]');
  var progressLbl = root.querySelector('[data-byob-progress]');
  var modeBtns = root.querySelectorAll('[data-byob-mode]');
  // Multiple checkout CTAs: sticky bar bottom + a duplicate inside the
  // subscribe sidebar (visual redundancy so users see a CTA whether their
  // attention is on the picks panel or on the sticky bar).
  var checkoutBtns = root.querySelectorAll('[data-byob-checkout]');
  var countNum = root.querySelector('[data-byob-count-num]');
  var countLbl = root.querySelector('[data-byob-count-lbl]');
  var priceTotal = root.querySelector('[data-byob-total]');
  var priceOriginal = root.querySelector('[data-byob-original]');
  var priceSave = root.querySelector('[data-byob-save]');
  // Subscribe-panel total (Sierra feedback: running total visible while building)
  var panelTotalWrap = root.querySelector('[data-byob-panel-total]');
  var panelTotalCurrent = root.querySelector('[data-byob-panel-current]');
  var panelTotalOriginal = root.querySelector('[data-byob-panel-original]');
  var panelTotalSave = root.querySelector('[data-byob-panel-save]');
  var benefitsLists = root.querySelectorAll('[data-byob-benefits]');
  var subOnlyFine = root.querySelector('[data-byob-sub-only-fine]');
  var grid = root.querySelector('.byob__grid');
  var toastEl = root.querySelector('[data-byob-toast]');
  var moneyFormat = root.getAttribute('data-byob-money-format') || '${{amount}}';

  // ---- State -------------------------------------------------
  var state = {
    tier: parseInt(root.getAttribute('data-byob-default-tier') || '3', 10),
    category: root.getAttribute('data-byob-default-category') || (pillBtns[0] && pillBtns[0].getAttribute('data-byob-category')) || '',
    bundle: {}, // { productHandle: { variantId, sellingPlanId, price, qty } }
    mode: 'sub'
  };

  // ---- Helpers -----------------------------------------------
  function fmtMoney(cents) {
    var amt = (cents / 100).toFixed(2);
    return moneyFormat.replace('{{amount}}', amt);
  }
  function tierConfig(size) {
    return config.tiers.find(function (t) { return t.size === size; }) || config.tiers[0];
  }
  function totalCount() {
    return Object.values(state.bundle).reduce(function (s, b) { return s + b.qty; }, 0);
  }
  function originalTotal() {
    return Object.values(state.bundle).reduce(function (s, b) { return s + b.price * b.qty; }, 0);
  }
  function tierRate(size, mode) {
    var t = tierConfig(size);
    return mode === 'sub' ? (t && t.subDiscount) || 0 : (t && t.onceDiscount) || 0;
  }
  function discountedTotal() {
    var orig = originalTotal();
    if (totalCount() < state.tier) return orig;
    return Math.round(orig * (1 - tierRate(state.tier, state.mode)));
  }

  var toastTimer = null;
  function showToast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('byob-toast--show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('byob-toast--show'); }, 1800);
  }

  // ---- Persistence -------------------------------------------
  // Saves state in sessionStorage so picks survive a reload (cleared when
  // the tab closes or after a successful cart-add). Stored shape:
  //   { tier, category, mode, bundle: { handle: { variantId, sellingPlanId, price, image, qty } } }
  // Storage values are validated against the rendered DOM (tier sizes,
  // category pills) before being applied — stale or hand-edited blobs
  // fall back to defaults rather than producing a broken state.
  var STORAGE_KEY = 'byob:state:v1';

  function persist() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        tier: state.tier,
        category: state.category,
        mode: state.mode,
        bundle: state.bundle
      }));
    } catch (e) { /* quota / disabled / private mode — silently skip */ }
  }
  function clearPersisted() {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }
  function hydrate() {
    var raw;
    try { raw = sessionStorage.getItem(STORAGE_KEY); } catch (e) { return; }
    if (!raw) return;
    var saved;
    try { saved = JSON.parse(raw); } catch (e) { clearPersisted(); return; }
    if (!saved || typeof saved !== 'object') return;

    var validTiers = Array.prototype.slice.call(tierBtns).map(function (b) {
      return parseInt(b.getAttribute('data-byob-tier'), 10);
    });
    if (validTiers.indexOf(saved.tier) >= 0) state.tier = saved.tier;

    if (saved.mode === 'once' || saved.mode === 'sub') state.mode = saved.mode;

    if (saved.category) {
      var validCats = Array.prototype.slice.call(pillBtns).map(function (b) {
        return b.getAttribute('data-byob-category');
      });
      if (validCats.indexOf(saved.category) >= 0) state.category = saved.category;
    }

    if (saved.bundle && typeof saved.bundle === 'object') {
      var trimmed = {};
      var kept = 0;
      Object.keys(saved.bundle).forEach(function (k) {
        var v = saved.bundle[k];
        if (!v || !v.variantId || typeof v.qty !== 'number' || v.qty < 1) return;
        if (kept >= state.tier) return;
        var qty = Math.min(v.qty, state.tier - kept);
        trimmed[k] = {
          variantId: v.variantId,
          sellingPlanId: v.sellingPlanId || null,
          price: typeof v.price === 'number' ? v.price : 0,
          image: v.image || '',
          qty: qty,
          name: v.name || '',
          // Bundle-SPG eligibility flags (added 2026-07-06). Absent in blobs
          // saved before this shipped → default true so a restored bundle is
          // never falsely blocked; fresh picks always carry the real values.
          bundle3: v.bundle3 !== false,
          bundle5: v.bundle5 !== false
        };
        kept += qty;
      });
      state.bundle = trimmed;
    }
  }

  // ---- Render --------------------------------------------------
  function render() {
    // Tier buttons
    tierBtns.forEach(function (b) {
      var s = parseInt(b.getAttribute('data-byob-tier'), 10);
      b.classList.toggle('byob__tier-btn--active', s === state.tier);
    });

    // Category pills + grid filtering
    var visibleCount = 0;
    pillBtns.forEach(function (b) {
      var cat = b.getAttribute('data-byob-category');
      b.classList.toggle('byob__pill--active', cat === state.category);
    });
    productCards.forEach(function (card) {
      var cat = card.getAttribute('data-byob-product-category');
      var visible = cat === state.category;
      card.style.display = visible ? '' : 'none';
      if (visible) visibleCount += 1;
    });
    if (emptyEl) emptyEl.style.display = visibleCount > 0 ? 'none' : '';
    // Center the grid when a category has only 1-2 cards (Sierra feedback) so
    // it doesn't look orphaned in the leftmost columns of a 4-up grid.
    if (grid) {
      grid.classList.toggle('byob__grid--few', visibleCount > 0 && visibleCount <= 2);
    }

    // Per-card selection state — uses the ACTIVE swatch's handle so users can toggle
    // shared-product flavor cards independently per flavor.
    productCards.forEach(function (card) {
      var sel = readActiveSelection(card);
      var entry = state.bundle[sel.handle];
      var added = !!entry && entry.qty > 0;
      card.classList.toggle('byob-product--selected', added);
      // Grey the card when its active flavor can't join a subscription bundle
      // for the current tier (keeps already-added items removable).
      card.classList.toggle('byob-product--bundle-ineligible', subIneligible(sel) && !added);
      var plus = card.querySelector('[data-byob-add]');
      if (plus) {
        plus.classList.toggle('byob-product__plus--added', added);
        plus.innerHTML = added ? '<span class="byob-product__plus-check">✓</span>' : '+';
        plus.setAttribute('aria-label', added ? 'Remove from bundle' : 'Add to bundle');
      }
    });

    // Subscribe slots — show product photos in insertion order, empty slots fall back
    // to the wireframe's bag icon (first slot) or an empty circle. Each filled slot
    // carries a remove (×) button so users can prune from the sidebar.
    if (slotsEl) {
      var entryPairs = Object.keys(state.bundle).map(function (h) { return [h, state.bundle[h]]; });
      var filled = Math.min(totalCount(), state.tier);
      var slotsHtml = '';
      for (var i = 0; i < state.tier; i++) {
        var pair = entryPairs[i];
        if (pair && pair[1].image) {
          slotsHtml += '<div class="byob-subscribe__slot byob-subscribe__slot--filled-img" data-byob-slot-handle="' + pair[0] + '">'
            + '<span class="byob-subscribe__slot-photo"><img src="' + pair[1].image + '" alt="" loading="lazy"></span>'
            + '<button type="button" class="byob-subscribe__slot-remove" data-byob-slot-remove aria-label="Remove from bundle">×</button>'
            + '</div>';
        } else if (i === 0) {
          slotsHtml += '<div class="byob-subscribe__slot byob-subscribe__slot--bag"></div>';
        } else {
          slotsHtml += '<div class="byob-subscribe__slot"></div>';
        }
      }
      slotsEl.innerHTML = slotsHtml;
      if (progressLbl) progressLbl.textContent = filled + ' of ' + state.tier + ' added';
    }

    // Mode buttons
    modeBtns.forEach(function (b) {
      var m = b.getAttribute('data-byob-mode');
      b.classList.toggle('byob-subscribe__opt--selected', m === state.mode);
    });

    // Tier save labels — reflect tier × mode so "Save N%" matches what'll actually be charged
    root.querySelectorAll('[data-byob-tier-save]').forEach(function (el) {
      var size = parseInt(el.getAttribute('data-byob-tier-save'), 10);
      var pct = Math.round(tierRate(size, state.mode) * 100);
      if (pct > 0) el.textContent = 'Save ' + pct + '%';
    });

    // Sub/once percentages on the mode toggles — both desktop panel and mobile
    // sticky bar. Each label tracks the active tier's rate for its mode.
    var subPct = Math.round(tierRate(state.tier, 'sub') * 100);
    var oncePct = Math.round(tierRate(state.tier, 'once') * 100);
    var subPctEl = root.querySelector('[data-byob-sub-pct]');
    if (subPctEl && subPct > 0) subPctEl.textContent = ' ' + subPct + '%';
    var subPctPanelEl = root.querySelector('[data-byob-sub-pct-panel]');
    if (subPctPanelEl && subPct > 0) subPctPanelEl.textContent = ' · Save ' + subPct + '%';
    var oncePctEl = root.querySelector('[data-byob-once-pct]');
    if (oncePctEl && oncePct > 0) oncePctEl.textContent = ' · Save ' + oncePct + '%';
    var oncePctMobileEl = root.querySelector('[data-byob-once-pct-mobile]');
    if (oncePctMobileEl && oncePct > 0) oncePctMobileEl.textContent = ' ' + oncePct + '%';

    // Benefits lists — strike through subscription-only items when in OTP mode
    // (Sierra feedback). The fine-print "Manage your subscription anytime" line
    // is treated the same way.
    benefitsLists.forEach(function (ul) {
      ul.classList.toggle('byob-benefits--once', state.mode === 'once');
    });
    if (subOnlyFine) subOnlyFine.classList.toggle('byob-benefits--once', state.mode === 'once');

    // Sticky bar
    var count = totalCount();
    var ready = count >= state.tier;
    var orig = originalTotal();
    var total = discountedTotal();

    if (countNum) countNum.textContent = count;
    if (countLbl) countLbl.textContent = count === 1 ? 'Item' : 'Items';
    if (priceTotal) priceTotal.textContent = fmtMoney(total);
    if (priceOriginal) {
      if (orig > total) {
        priceOriginal.textContent = fmtMoney(orig);
        priceOriginal.style.display = '';
      } else {
        priceOriginal.style.display = 'none';
      }
    }
    var activePct = Math.round(tierRate(state.tier, state.mode) * 100);
    var projectedSaving = Math.round(orig * tierRate(state.tier, state.mode));
    if (priceSave) {
      if (ready && orig > total) {
        priceSave.textContent = 'You save ' + fmtMoney(orig - total) + ' (' + activePct + '%)';
        priceSave.style.display = '';
      } else if (count > 0 && activePct > 0) {
        priceSave.textContent = 'Save ' + activePct + '% when complete';
        priceSave.style.display = '';
      } else {
        priceSave.style.display = 'none';
      }
    }
    var remaining = state.tier - count;
    var ctaLabel = ready
      ? 'Continue to Cart <span style="margin-left:6px">→</span>'
      : ('Add ' + remaining + ' more item' + (remaining === 1 ? '' : 's'));
    checkoutBtns.forEach(function (b) {
      b.disabled = !ready;
      b.innerHTML = ctaLabel;
    });

    // Sticky bar visibility — hidden when bundle is empty, slides up after first add
    var checkoutBar = root.querySelector('.byob-checkout');
    if (checkoutBar) checkoutBar.classList.toggle('byob-checkout--hidden', count === 0);

    // Subscribe-panel running total — visible from the first add, mirrors the
    // sticky bar's three figures (current, original-strikethrough, savings)
    if (panelTotalWrap) {
      if (count === 0) {
        panelTotalWrap.setAttribute('hidden', '');
      } else {
        panelTotalWrap.removeAttribute('hidden');
      }
    }
    if (panelTotalCurrent) panelTotalCurrent.textContent = fmtMoney(total);
    if (panelTotalOriginal) {
      if (orig > total) {
        panelTotalOriginal.textContent = fmtMoney(orig);
        panelTotalOriginal.style.display = '';
      } else {
        panelTotalOriginal.style.display = 'none';
      }
    }
    if (panelTotalSave) {
      if (ready && orig > total) {
        panelTotalSave.textContent = 'You save ' + fmtMoney(orig - total) + ' (' + activePct + '%)';
        panelTotalSave.style.display = '';
      } else if (count > 0 && activePct > 0) {
        panelTotalSave.textContent = 'Save ' + activePct + '% (' + fmtMoney(projectedSaving) + ') when bundle is complete';
        panelTotalSave.style.display = '';
      } else {
        panelTotalSave.style.display = 'none';
      }
    }

    persist();
  }

  // ---- Handlers ---------------------------------------------
  tierBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      var newTier = parseInt(b.getAttribute('data-byob-tier'), 10);
      if (newTier === state.tier) return;
      // If user has more items than the new tier, drop excess (keep insertion order)
      var keep = {};
      var kept = 0;
      Object.keys(state.bundle).forEach(function (k) {
        var qty = state.bundle[k].qty;
        if (kept + qty <= newTier) {
          keep[k] = state.bundle[k];
          kept += qty;
        } else if (kept < newTier) {
          keep[k] = Object.assign({}, state.bundle[k], { qty: newTier - kept });
          kept = newTier;
        }
      });
      state.bundle = keep;
      state.tier = newTier;
      render();
    });
  });

  pillBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      state.category = b.getAttribute('data-byob-category');
      render();
    });
  });

  productCards.forEach(function (card) {
    var addBtn = card.querySelector('[data-byob-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        var sel = readActiveSelection(card);
        if (state.bundle[sel.handle] && state.bundle[sel.handle].qty > 0) {
          delete state.bundle[sel.handle];
          render();
          return;
        }
        // Block adding a sold-out flavor — the variant would 422 at /cart/add.js.
        if (sel.soldOut) {
          showToast('That flavor is sold out.');
          return;
        }
        // Block adding a flavor that isn't part of this tier's Bundle SPG while
        // in subscription mode — it would 422 ("Cannot apply selling plan to
        // variant") and reject the whole /cart/add.js.
        if (subIneligible(sel)) {
          showToast('Not available for subscription bundles — switch to One-Time to add it.');
          return;
        }
        if (totalCount() >= state.tier) {
          showToast('Bundle full (' + state.tier + '). Remove an item or pick the ' + (state.tier === 3 ? '5' : '3') + '-pack.');
          return;
        }
        state.bundle[sel.handle] = sel;
        render();
      });
    }

    // Swatch clicks: update active swatch, swap photo + name + price, re-render so
    // the +/✓ button reflects the newly-active product's bundle status.
    var swatches = card.querySelectorAll('[data-byob-swatch]');
    var photoImg = card.querySelector('[data-byob-photo-img]');
    var nameEl = card.querySelector('[data-byob-name]');
    var priceEl = card.querySelector('[data-byob-price-current]');
    swatches.forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        e.stopPropagation();
        // Sold-out flavor: don't activate it (keeps the active selection on an
        // in-stock flavor so the + stays addable) — just tell the customer.
        if (sw.getAttribute('data-byob-swatch-soldout') === 'true') {
          showToast('That flavor is sold out.');
          return;
        }
        swatches.forEach(function (x) { x.classList.remove('byob-product__swatch--active'); });
        sw.classList.add('byob-product__swatch--active');

        var newImg = sw.getAttribute('data-byob-swatch-image');
        if (newImg && photoImg) photoImg.src = newImg;

        var newName = sw.getAttribute('data-byob-swatch-name');
        if (newName && nameEl) nameEl.textContent = newName;

        var newPriceMoney = sw.getAttribute('data-byob-swatch-price-money');
        if (newPriceMoney && priceEl) priceEl.textContent = newPriceMoney;

        render();
      });
    });

    // Normalize the default selection: if the active swatch is sold out, switch
    // to the first in-stock swatch so the card never defaults to an unaddable
    // flavor. If every swatch is sold out, disable the + and grey the card.
    if (swatches.length) {
      var activeSw = card.querySelector('.byob-product__swatch--active') || swatches[0];
      if (activeSw && activeSw.getAttribute('data-byob-swatch-soldout') === 'true') {
        var firstAvail = null;
        swatches.forEach(function (s) {
          if (!firstAvail && s.getAttribute('data-byob-swatch-soldout') !== 'true') firstAvail = s;
        });
        if (firstAvail) {
          swatches.forEach(function (x) { x.classList.remove('byob-product__swatch--active'); });
          firstAvail.classList.add('byob-product__swatch--active');
          var ni = firstAvail.getAttribute('data-byob-swatch-image');
          if (ni && photoImg) photoImg.src = ni;
          var nn = firstAvail.getAttribute('data-byob-swatch-name');
          if (nn && nameEl) nameEl.textContent = nn;
          var np = firstAvail.getAttribute('data-byob-swatch-price-money');
          if (np && priceEl) priceEl.textContent = np;
        } else if (addBtn) {
          addBtn.disabled = true;
          card.classList.add('byob-product--soldout');
        }
      }
    }
  });

  function readActiveSelection(card) {
    var activeSwatch = card.querySelector('.byob-product__swatch--active') || card.querySelector('[data-byob-swatch]');
    var leadHandle = card.getAttribute('data-byob-product');
    var handle = (activeSwatch && activeSwatch.getAttribute('data-byob-swatch-handle')) || leadHandle;
    var variantId = activeSwatch
      ? activeSwatch.getAttribute('data-byob-swatch-variant')
      : card.getAttribute('data-byob-default-variant');
    var sellingPlanId = activeSwatch
      ? activeSwatch.getAttribute('data-byob-swatch-selling-plan')
      : card.getAttribute('data-byob-default-selling-plan');
    var swatchPriceCents = activeSwatch && activeSwatch.getAttribute('data-byob-swatch-price-cents');
    var price = swatchPriceCents
      ? parseInt(swatchPriceCents, 10)
      : parseInt(card.getAttribute('data-byob-price-cents') || '0', 10);
    var photoImg = card.querySelector('[data-byob-photo-img]');
    var swatchImage = activeSwatch && activeSwatch.getAttribute('data-byob-swatch-image');
    var image = swatchImage || (photoImg && photoImg.src) || '';
    var soldOut = activeSwatch
      ? activeSwatch.getAttribute('data-byob-swatch-soldout') === 'true'
      : card.getAttribute('data-byob-default-soldout') === 'true';
    var name = activeSwatch
      ? (activeSwatch.getAttribute('data-byob-swatch-name') || '')
      : ((card.querySelector('[data-byob-name]') || {}).textContent || '').trim();
    // Bundle-SPG membership per tier — is this product an allowed child of the
    // 3-Pack / 5-Pack Bundle SPG? Emitted by byob-bundle-eligibility.liquid.
    var bundle3 = activeSwatch
      ? activeSwatch.getAttribute('data-byob-swatch-bundle3') === 'true'
      : card.getAttribute('data-byob-default-bundle3') === 'true';
    var bundle5 = activeSwatch
      ? activeSwatch.getAttribute('data-byob-swatch-bundle5') === 'true'
      : card.getAttribute('data-byob-default-bundle5') === 'true';
    return {
      handle: handle,
      variantId: variantId,
      sellingPlanId: sellingPlanId || null,
      price: price,
      image: image,
      qty: 1,
      soldOut: soldOut,
      name: name,
      bundle3: bundle3,
      bundle5: bundle5
    };
  }

  // A picked product can only ride the bundle selling plan in subscription mode
  // if it's an allowed child of the current tier's Bundle SPG. Sending the
  // bundle plan on a non-member 422s ("Cannot apply selling plan to variant")
  // and — because /cart/add.js is atomic — rejects the ENTIRE bundle. So we gate
  // non-members whenever mode === 'sub'. One-time mode is unaffected (the
  // byob-discount Function applies the %, no selling plan involved).
  function subIneligible(sel) {
    if (!sel || state.mode !== 'sub') return false;
    return state.tier === 3 ? !sel.bundle3 : !sel.bundle5;
  }

  modeBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      state.mode = b.getAttribute('data-byob-mode');
      render();
    });
  });

  // Slot remove (×) — delegated since slots are re-rendered on every state change.
  if (slotsEl) {
    slotsEl.addEventListener('click', function (e) {
      var removeBtn = e.target.closest && e.target.closest('[data-byob-slot-remove]');
      if (!removeBtn) return;
      var slot = removeBtn.closest('[data-byob-slot-handle]');
      if (!slot) return;
      var handle = slot.getAttribute('data-byob-slot-handle');
      if (handle && state.bundle[handle]) {
        delete state.bundle[handle];
        render();
      }
    });
  }

  // ---- Cart-add ------------------------------------------------
  // Property convention follows Stay.ai's BYOB-v2r reference (lsg-bundle.js,
  // lsg-cart.js): unprefixed `bundle_id` UUID on every line, boolean
  // `bundle_parent: true` on the parent only. In sub mode every line — parent
  // AND children — carries the BYOB Bundle SPG plan (tCfg.sellingPlanId). The
  // Stay.ai Bundle SPG is bundleLineType=STANDARD, so the bundle is composed of
  // standard lines and the 20%/30% bundle discount rides on EACH child line's
  // selling-plan allocation. The bundle SPG is attached to all BYOB-eligible
  // children (Stay.ai SPG rollout 2026-05-19), so children can carry it — it no
  // longer 422s. (Previously each child used v.sellingPlanId, its own default
  // S&S plan at ~10-20%, so the cart applied a variable blended rate instead of
  // the advertised bundle %, undercharging the discount at checkout.)
  // Drawer obfuscation is handled by assets/byob-rebuy-fold.js — Rebuy
  // SmartCart does NOT natively recognize bundle_id/bundle_parent, only Cart
  // Transform Function output.
  function bundleUuid() {
    var d = Date.now();
    var d2 = (typeof performance !== 'undefined' && performance.now) ? performance.now() * 1000 : 0;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16;
      if (d > 0) { r = (d + r) % 16 | 0; d = Math.floor(d / 16); }
      else { r = (d2 + r) % 16 | 0; d2 = Math.floor(d2 / 16); }
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  function handleCheckoutClick() {
    // Disabled-state guard — render() keeps every checkout button in sync,
    // so checking the first one is enough.
    if (checkoutBtns[0] && checkoutBtns[0].disabled) return;
    var tCfg = tierConfig(state.tier);
    if (!tCfg || !tCfg.parentVariantId) {
      showToast('Bundle parent variant not configured.');
      return;
    }

    // Safety net: never POST a subscription bundle containing an item that can't
    // ride the bundle plan for this tier — Shopify would 422 the whole atomic
    // /cart/add.js. Selection-time gating (subIneligible) normally prevents this,
    // but this also catches items added in One-Time mode, then switched to
    // Subscribe, and stale hydrated state.
    if (state.mode === 'sub') {
      var blocked = Object.keys(state.bundle).filter(function (h) {
        var v = state.bundle[h];
        return state.tier === 3 ? v.bundle3 === false : v.bundle5 === false;
      }).map(function (h) { return state.bundle[h].name || h; });
      if (blocked.length) {
        showToast(blocked.join(', ') + (blocked.length === 1 ? " isn't" : " aren't")
          + ' available for subscription bundles — remove '
          + (blocked.length === 1 ? 'it' : 'them') + ' or switch to One-Time.');
        return;
      }
    }

    var bundleId = bundleUuid();
    var sellingPlanId = (state.mode === 'sub' && tCfg.sellingPlanId)
      ? parseInt(tCfg.sellingPlanId, 10)
      : null;

    var parentItem = {
      id: parseInt(tCfg.parentVariantId, 10),
      quantity: 1,
      properties: { bundle_id: bundleId, bundle_parent: true }
    };
    if (sellingPlanId) parentItem.selling_plan = sellingPlanId;

    var children = Object.values(state.bundle).flatMap(function (v) {
      var arr = [];
      var childPlanId = (state.mode === 'sub' && tCfg.sellingPlanId)
        ? parseInt(tCfg.sellingPlanId, 10)
        : null;
      for (var i = 0; i < v.qty; i++) {
        // `_bundle_flag` + `_bundle_sku` (parent SKU) ride on each child line
        // for finance/reporting — they group the component SKUs under the
        // parent bundle without tagging the whole order (Olivia U., 2026-06-26).
        // Underscore-prefixed so Shopify hides them from the customer at cart +
        // checkout, while still storing them on the order — Olivia's report
        // reads line-item properties via the Admin API, which returns
        // `_`-prefixed keys too. Unlike `bundle_id`/`bundle_parent` (which MUST
        // stay unprefixed because Stay.ai + Rebuy + the discount Function key
        // off them), these two have no integration consumer, so prefixing is
        // safe.
        var child = {
          id: parseInt(v.variantId, 10),
          quantity: 1,
          properties: { bundle_id: bundleId, _bundle_flag: 'Y' }
        };
        if (tCfg.parentSku) child.properties._bundle_sku = tCfg.parentSku;
        if (childPlanId) child.selling_plan = childPlanId;
        arr.push(child);
      }
      return arr;
    });

    var items = [parentItem].concat(children);

    checkoutBtns.forEach(function (b) {
      b.disabled = true;
      b.textContent = 'Adding…';
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        // Bundle is committed to the Shopify cart now — wipe the local
        // draft so a reload after checkout doesn't re-hydrate the same picks.
        state.bundle = {};
        clearPersisted();

        // Refresh cart count + open Rebuy SmartCart if available
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (typeof window.update_cart_count_elements === 'function') {
              window.update_cart_count_elements(cart.item_count);
            }
          });
        if (window.Rebuy && window.Rebuy.SmartCart) {
          if (window.Rebuy.SmartCart.refresh) window.Rebuy.SmartCart.refresh();
          if (window.Rebuy.SmartCart.show) window.Rebuy.SmartCart.show();
        }
        document.dispatchEvent(new CustomEvent('rebuy:cart.add'));
      })
      .catch(function (err) {
        showToast((err && err.description) || 'Could not add bundle to cart');
      })
      .finally(function () {
        render();
      });
  }
  checkoutBtns.forEach(function (b) { b.addEventListener('click', handleCheckoutClick); });

  // After hydration, reconcile each card's active swatch with the stored
  // bundle entries. The HTML's initial swatch state is "first one active",
  // but state.bundle may carry a non-default flavor handle (e.g. the user
  // picked Florida Orange of Debloat, then reloaded). Without this pass,
  // readActiveSelection() returns the default-flavor handle, doesn't find
  // it in state.bundle, and the card renders unmarked even though the slot
  // photos correctly show the picked flavor's image.
  function restoreSwatchesFromState() {
    productCards.forEach(function (card) {
      var swatches = card.querySelectorAll('[data-byob-swatch]');
      if (swatches.length === 0) return;
      var match = null;
      for (var i = 0; i < swatches.length; i++) {
        var h = swatches[i].getAttribute('data-byob-swatch-handle');
        if (h && state.bundle[h]) { match = swatches[i]; break; }
      }
      if (!match) return;

      swatches.forEach(function (x) { x.classList.remove('byob-product__swatch--active'); });
      match.classList.add('byob-product__swatch--active');

      var photoImg = card.querySelector('[data-byob-photo-img]');
      var newImg = match.getAttribute('data-byob-swatch-image');
      if (newImg && photoImg) photoImg.src = newImg;

      var nameEl = card.querySelector('[data-byob-name]');
      var newName = match.getAttribute('data-byob-swatch-name');
      if (newName && nameEl) nameEl.textContent = newName;

      var priceEl = card.querySelector('[data-byob-price-current]');
      var newPriceMoney = match.getAttribute('data-byob-swatch-price-money');
      if (newPriceMoney && priceEl) priceEl.textContent = newPriceMoney;
    });
  }

  hydrate();
  restoreSwatchesFromState();
  render();
})();
